import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { X } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}

function SortableItem({ id, children }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: "grab",
        background: "#fafafa",
        padding: "6px 10px",
        marginBottom: "5px",
        border: "1px solid #ddd",
        borderRadius: "6px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    };

    return (
        <li ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {children}
        </li>
    );
}


const SimpleProduct = () => {
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    const url = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""

    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        originalPrice: '',
        discountPrice: '',
        product_type: { value: 'Simple Product', label: 'Simple Product' },
        category: null,

        totalStock: '',
        stock: '',
        status: null,
        typeofsimple: "virtual",
        categorytype: [],
        short_description: "",
        description: "",
        // grouped_products: [],
        product_url: "",
        button_text: "",
        stock: "",
        download_limit: null,
        download_expiry: null,
        downloadable_files: [],
        sku: "",
        weight: "",
        length: "",
        width: "",
        height: "",

        user_name: user.full_name,
        delivery_days: "",
        key_features: [],
        specifications: [],
        category_id: "",
        categorytype_id: [],
        warranty: "Yes",
        warranty_from: "",
        warranty_note: "",
        brand_name: "",
        installation: "",
        installation_fee: "",
        brand_id: [],
        gst: "",

        add_to_cart: false,
        buy_now: false,
        hsn: ""
    });
    const [brand, setBrand] = useState([]);
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const [loading, setLoading] = useState(false);

    const [activeIndex, setActiveIndex] = useState(null);
    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        if (!user?.main_id) return; // wait until user is available

        // const generateSKU = () => {
        //     const now = new Date();
        //     const pad = (n) => n.toString().padStart(2, '0');
        //     const skuTimestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        //     return `Sku-SML-${user.main_id}-${skuTimestamp}`;
        // };

        const generateSKU = () => {
            // last 7 chars of base36 timestamp
            const uniquePart = Date.now().toString(36).toUpperCase().slice(-7);
            return `SM${uniquePart}`;
        };


        setFormData(prev => ({
            ...prev,
            sku: generateSKU()
        }));
    }, []);


    const fetchBrand = async () => {
        try {
            const response = await fetch(`${url}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();

            const options = res.data.map(cat => ({
                value: cat.id,
                label: cat.name || cat.name || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top


            setBrand(options);
        } catch (error) {
            console.error(error);
        }
    };

    const handleButtonChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };


    const updateVariation = (index, field, value) => {
        setVariations(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    const [categories, setCategories] = useState([]);


    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();

            const options = res.map(cat => ({
                value: cat.id,
                label: cat.category || cat.category || cat.category,
                id: cat.id
            }));
            setCategories(options);
        } catch (error) {
            console.error(error)
        }
    }




    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const navigate = useNavigate();

    const [isUploadModalOpen, setUploadModalOpen] = useState(false);
    const [groupedModal, setShowGroupedModal] = useState(false)

    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };


    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }


    const updateTypeofSimple = (key, isChecked) => {
        let updatedTypes = formData.typeofsimple.split(',').filter(Boolean);

        if (key === 'virtual' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['virtual'];
        } else if (key === 'downloadable' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['downloadable'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            typeofsimple: updatedTypes.join(',')
        }));
    };

    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = [...formData.categorytype];

        if (isChecked) {
            if (!updatedTypes.includes(key)) updatedTypes.push(key);
        } else {
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes
        }));
    };

    const updateTypeofWar = (key, isChecked) => {
        let updatedTypes = [...formData.warranty];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            warranty: updatedTypes
        }));
    };

    const updateTypeofWarfrom = (key, isChecked) => {
        let updatedTypes = [...formData.warranty_from];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            warranty_from: updatedTypes
        }));
    };


    const updateTypeofInstall = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            installation: updatedTypes,
        }));
    };


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };

    const handleSelectChangeBrand = (selectedOption, { name }) => {

        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,               // keep label+value for UI
            brand_id: selectedOption?.value || "", // keep value for backend
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (Number(formData.discountPrice) > Number(formData.originalPrice)) {
            toast.warning("Sale price should not be greater than Original Price", {
                position: "top-center",
                autoClose: 2000
            })
            return;
        }
        if (formData.title === "" || formData.title === null) {
            toast.warning("Add Product Title", {
                position: "top-center",
                autoClose: 2000
            })
            return;
        }
        try {
            const payload = {
                ...formData,
                warranty: Array.isArray(formData.warranty)
                    ? formData.warranty[0] || ""
                    : formData.warranty,

                warranty_from: Array.isArray(formData.warranty_from)
                    ? formData.warranty_from[0] || ""
                    : formData.warranty_from,

                installation: Array.isArray(formData.installation)
                    ? formData.installation[0] || ""
                    : formData.installation,
                image: formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                categorytype: Array.isArray(formData.categorytype)
                    ? formData.categorytype.join(',')
                    : formData.categorytype,
                category: formData.category?.value || "",
                category_id: formData.category?.value || "",
                user_name: user.full_name,
                brand_name: formData.brand_name?.value || formData?.brand_name || "",
                // warranty_from: formData.warranty_from[0] || "",
                // installation: formData.installation[0] || "",
                hsn: formData.hsn || ""
            };

            const response = await fetch(`${url}/simple-product/admin1997`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product added successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
                console.log("Product submitted successfully");
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
                setLoading(false)
            }

        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setLoading(false);
        }
    };

    console.log(formData)

    const handleImageSelect = (imgs) => {
        const isValidImage = (file) => {
            const url = file?.url || file;
            const fileName = typeof url === 'string' ? url : '';
            const extension = fileName.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'webp'].includes(extension);
        };

        const invalidFiles = Array.isArray(imgs) ? imgs.filter(img => !isValidImage(img)) : [imgs].filter(img => !isValidImage(img));

        if (invalidFiles.length > 0) {
            alert("Only image files (JPG, PNG, WEBP) are allowed.");
            return;
        }

        // Valid images – update formData
        setFormData((prev) => ({
            ...prev,
            gallery: Array.isArray(imgs)
                ? [...prev.gallery, ...imgs]
                : [...prev.gallery, imgs]
        }));
    };


    const handleSingleImageSelect = (img) => {
        const url = img?.url || img;
        const fileName = typeof url === 'string' ? url : '';
        const extension = fileName.split('.').pop().toLowerCase();

        const validExtensions = ['jpg', 'jpeg', 'png', 'webp'];

        if (!validExtensions.includes(extension)) {
            toast.success("Only image files (JPG, PNG, JPEG, WEBP) are allowed.");
            return;
        }

        // Valid image – set image
        setFormData((prev) => ({
            ...prev,
            image: [img]
        }));
    };

    const handleNavigate = (url) => {
        navigate(url)
    };




    useEffect(() => {
        handleImageView();
        fetchCategories();
        fetchBrand();
    }, [])

    return (
        <>

            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Simple Product</h1>
                    {
                        loading ? <button className="oms-add-btn">
                            Publishing...
                        </button> : <button onClick={handleSubmit} className="oms-add-btn">
                            Publish
                        </button>
                    }

                    {/* <div className="property-dropdown-wrapper">
                                            <button className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                                                Add Products
                                            </button>
                                            {isOpen && (
                                                <ul className="property-dropdown-menu">
                                                    <li onClick={() => handleNavigate('/simple-product')}>
                                                        Simple Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                                        Affiliate Product
                                                    </li> 
                                                    <li onClick={() => handleNavigate('/variable-product')}>
                                                        Variable Product
                                                    </li>
                                                </ul>
                                            )}
                                        </div> */}
                </div>
                <form className="oms-modal-form property-form" onSubmit={handleSubmit}>
                    <div className='oms-givepaddingfrom'>
                        {/* <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Type
                            </label>
                            <Select
                                options={ProductOptions}
                                placeholder="Select Product Type"
                                name="product_type"
                                value={formData.product_type}
                                onChange={handleSelectChange}
                                isDisabled
                            />
                        </div> */}

                        {
                            formData.product_type.value === "Simple Product" && (
                                <div className="oms-form-group">
                                    <label className="oms-form-label">Choose Type</label>
                                    <div className="oms-checkbox-group">
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="virtual"
                                                checked={formData.typeofsimple.includes("virtual")}
                                                onChange={(e) => updateTypeofSimple("virtual", e.target.checked)}
                                            />
                                            <label htmlFor="virtual">Virtual</label>
                                        </div>
                                        <div className="oms-checkbox-item">
                                            <input
                                                type="checkbox"
                                                id="downloadable"
                                                checked={formData.typeofsimple.includes("downloadable")}
                                                onChange={(e) => updateTypeofSimple("downloadable", e.target.checked)}
                                            />

                                            <label htmlFor="downloadable">Downloadable</label>
                                        </div>
                                    </div>
                                </div>
                            )
                        }


                        {/* Title */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Product Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                name='title'
                                placeholder="Enter product name"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter a brief summary for quick view"
                            />
                        </div>



                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Product Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, description: value }))
                                }
                                style={{ backgroundColor: "#fefffc" }}
                                placeholder="Enter a detailed product description"
                            />
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Main Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Product Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : formData.image[0]}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}

                                    >
                                        <i class="fa-solid fa-xmark"></i>
                                    </p>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            // onImageSelect={handleSingleImageSelect}
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Additional Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} style={{ display: 'inline-block', marginRight: 10, position: 'relative' }}>
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className='gallery-preview-image'
                                        // style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}

                                        >
                                            <i class="fa-solid fa-xmark"></i>
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery} // 🔁 separate state
                            handleClose={() => setShowImageModalGallery(false)}
                            selectedGalleryImages={formData.gallery}
                            images={images}
                            multiple={true}
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        // onImageSelect={(imgs) => handleImageSelect(imgs)}
                        />



                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <div className="oms-form-group">
                                    <label htmlFor="status" className="oms-form-label">
                                        Downloadable files
                                    </label>
                                    <DownloadableFiles downloadable_files={formData.downloadable_files} setFormData={setFormData} />
                                </div> : null
                        }
                        {
                            (formData.typeofsimple === "downloadable" && formData.product_type.value === "Simple Product") ?
                                <>
                                    <div className="oms-form-group">
                                        <label htmlFor="download_limit" className="oms-form-label">
                                            Download Limit
                                        </label>
                                        <input
                                            type="number"
                                            id="download_limit"
                                            name='download_limit'
                                            placeholder="Unlimited"
                                            value={formData.download_limit}
                                            onChange={handleChange1}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="download_expiry" className="oms-form-label">
                                            Download Expiry
                                        </label>
                                        <input
                                            type="number"
                                            id="download_expiry"
                                            name='download_expiry'
                                            placeholder="Enter the number of days before a download link expires, or leave blank."
                                            value={formData.download_expiry}
                                            onChange={handleChange1}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                </>
                                : null
                        }

                        {/* Original Price */}
                        <div className="oms-form-group">
                            <label htmlFor="originalPrice" className="oms-form-label">
                                MRP (Original Price)
                            </label>
                            <input
                                type="number"
                                id="originalPrice"
                                placeholder="Enter MRP before discount"
                                value={formData.originalPrice}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        {/* Discount Price */}
                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Sale Price
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter discounted selling price"
                                value={formData.discountPrice}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />

                            {
                                formData.originalPrice &&
                                    formData.discountPrice &&
                                    Number(formData.discountPrice) > Number(formData.originalPrice) ? (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        Sale price should not be greater than Original Price
                                    </span>
                                ) : null
                            }

                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                SKU Code
                            </label>
                            <input
                                type="text"
                                id="sku"
                                placeholder="Enter Stock Keeping Unit (SKU)"
                                value={formData.sku}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Stock status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select stock availability"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}

                            />
                        </div>

                        {
                            formData.stock.value === "Unlimited Stock" ? null :
                                <div className="oms-form-group">
                                    <label htmlFor="totalStock" className="oms-form-label">
                                        Total Stock
                                    </label>
                                    <input
                                        type="number"
                                        id="totalStock"
                                        placeholder="Enter available quantity"
                                        value={formData.totalStock}
                                        onChange={handleChange1}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                        }

                        <div className="oms-form-group">
                            <label htmlFor="weight" className="oms-form-label">
                                Product Weight
                            </label>
                            <input
                                type="number"
                                id="weight"
                                placeholder="Enter Weight"
                                value={formData.weight}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label className="oms-form-label">Dimensions (cm)</label>
                            <div className="oms-dimensions-row">
                                <input
                                    type="number"
                                    placeholder="Length"
                                    value={formData.length}
                                    onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <input
                                    type="number"
                                    placeholder="Width"
                                    value={formData.width}
                                    onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                                <input
                                    type="number"
                                    placeholder="Height"
                                    value={formData.height}
                                    onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        </div>

                        {/* Key Features */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter main highlights/features"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: [...prev.key_features, keyFeatureInput.trim()],
                                            }));
                                            setKeyFeatureInput('');
                                        }
                                    }}
                                    style={{ marginTop: "10px" }}
                                >
                                    Add More
                                </button>
                            </div>
                            <ul className="oms-tag-list">
                                {formData.key_features.map((feature, index) => (
                                    <li key={index} className="oms-tag-item">
                                        {feature}
                                        <X
                                            type="button"
                                            className="oms-tag-delete"
                                            onClick={() => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    key_features: prev.key_features.filter((_, i) => i !== index),
                                                }));
                                            }}
                                            size={14}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Product Specifications</label>
                            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Add specification label (Max 25 Characters)"
                                    value={specInput.label}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 25) {
                                            setSpecInput((prev) => ({ ...prev, label: e.target.value }));
                                        }
                                    }}
                                // onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Add specification value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData(prev => ({
                                                ...prev,
                                                specifications: [
                                                    ...prev.specifications,
                                                    { id: crypto.randomUUID(), label: specInput.label, value: specInput.value }
                                                ],
                                            }));

                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;
                                    if (active.id !== over.id) {
                                        const oldIndex = formData.specifications.findIndex(s => s.id === active.id);
                                        const newIndex = formData.specifications.findIndex(s => s.id === over.id);

                                        const reordered = arrayMove(formData.specifications, oldIndex, newIndex);

                                        setFormData(prev => ({
                                            ...prev,
                                            specifications: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={formData.specifications.map(s => s.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {formData.specifications.map((spec, index) => (
                                            <li key={index} className="oms-tag-item">
                                                <strong>{spec.label}:</strong> {spec.value}
                                                <X
                                                    type="button"
                                                    className="oms-tag-delete"
                                                    onClick={() => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            specifications: prev.specifications.filter(s => s.id !== spec.id),
                                                        }));
                                                    }}
                                                    size={14}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Product Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select a category for this product"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="brand_name" className="oms-form-label">
                                Brand
                            </label>
                            <Select
                                options={brand}
                                placeholder="Select brand"
                                name="brand_name"
                                value={formData.brand_name}
                                onChange={handleSelectChangeBrand}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Yes"
                                        checked={formData.warranty.includes("Yes")}
                                        onChange={(e) => updateTypeofWar("Yes", e.target.checked)}
                                    />
                                    <label htmlFor="Yes">Yes</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="No"
                                        checked={formData.warranty.includes("No")}
                                        onChange={(e) => updateTypeofWar("No", e.target.checked)}
                                    />

                                    <label htmlFor="No">No</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty From</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Us"
                                        checked={formData.warranty_from.includes("Us")}
                                        onChange={(e) => updateTypeofWarfrom("Us", e.target.checked)}
                                    />
                                    <label htmlFor="Us">Us</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Brand"
                                        checked={formData.warranty_from.includes("Brand")}
                                        onChange={(e) => updateTypeofWarfrom("Brand", e.target.checked)}
                                    />

                                    <label htmlFor="Brand">Brand</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="warranty_note" className="oms-form-label">
                                Warranty note
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.warranty_note}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, warranty_note: value }))
                                }
                                placeholder="Enter Warranty Note"
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Time (Days)
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter estimated delivery time"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Home Display Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Installation</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Free Installation"
                                        checked={formData.installation.includes("Free Installation")}
                                        onChange={(e) => updateTypeofInstall("Free Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Free Installation">Free Installation</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Paid Installation"
                                        checked={formData.installation.includes("Paid Installation")}
                                        onChange={(e) => updateTypeofInstall("Paid Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Paid Installation">Paid Installation</label>
                                </div>
                            </div>
                        </div>

                        {
                            formData?.installation[0] === "Paid Installation" &&
                            <div className="oms-form-group">
                                <label htmlFor="installation_fee" className="oms-form-label">
                                    Installation Fee
                                </label>
                                <input
                                    type="number"
                                    id="installation_fee"
                                    placeholder="Enter Installation Fee"
                                    value={formData.installation_fee}
                                    onChange={handleChange1}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        }
                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                GST (%)
                            </label>
                            <input
                                type="number"
                                id="gst"
                                placeholder="Enter GST in percentage"
                                value={formData.gst}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Button</label>
                            <div className="oms-checkbox-group">

                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="add_to_cart"
                                        checked={formData.add_to_cart}
                                        onChange={(e) => handleButtonChange("add_to_cart", e.target.checked)}
                                    />
                                    <label htmlFor="add_to_cart">Add to Cart</label>
                                </div>

                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="buy_now"
                                        checked={formData.buy_now}
                                        onChange={(e) => handleButtonChange("buy_now", e.target.checked)}
                                    />
                                    <label htmlFor="buy_now">Buy Now</label>
                                </div>

                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="hsn" className="oms-form-label">
                                HSN CODE
                            </label>
                            <input
                                type="text"
                                id="hsn"
                                placeholder="Enter HSN CODE"
                                value={formData.hsn}
                                onChange={handleChange1}
                            />
                        </div>

                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Product Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select visibility status (Active/Draft)"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        <div className="oms-form-actions">
                            {
                                loading ? <button type="button" className='post-property-submit'>Publishing...</button> :
                                    <button type="submit" className='post-property-submit'>Publish</button>
                            }

                        </div>
                    </div>

                </form >
            </div >
        </>
    );
};

export default SimpleProduct;


const DownloadableFiles = ({ downloadable_files, setFormData }) => {
    const [files, setFiles] = useState(
        downloadable_files && downloadable_files.length > 0
            ? downloadable_files
            : [{ name: '', url: '', file: null }]
    );
    const [activeModalIndex, setActiveModalIndex] = useState(null);
    const [images, setImages] = useState([]);
    const url = process.env.REACT_APP_LINK;
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    const handleAddFile = () => {
        const updatedFiles = [...files, { name: '', url: '', file: null }];
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
        setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
    };

    const handleImageView = async () => {
        try {
            const response = await axios.get(`${url}/api/images/${user.main_id}`);
            setImages((response.data).reverse());
        } catch (err) {
            console.error("Failed to load images", err);
        }
    };

    useEffect(() => {
        handleImageView();
    }, []);

    return (
        <div className="downloadable-section">
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="Enter descriptive file name (e.g. Brochure, Specs, Manual)"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Paste file URL or use 'Browse Files'"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            className='upload-tab-button'
                            onClick={() => setActiveModalIndex(index)}
                        >
                            Browse Files
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <X className="remove-btn" onClick={() => handleRemoveFile(index)} />

                        <ImageModalDownloadable
                            show={activeModalIndex === index}
                            handleClose={() => setActiveModalIndex(null)}
                            images={images}
                            onImageSelect={(img) => {
                                const updatedFiles = [...files];
                                updatedFiles[index].url = `${url}${img.url}`;
                                setFiles(updatedFiles);
                                setFormData(prev => ({ ...prev, downloadable_files: updatedFiles }));
                                setActiveModalIndex(null);
                            }}
                            multiple={false}
                            setImages={setImages}
                        />
                    </div>
                ))}

                <button className="download-file-add-btn" type="button" onClick={handleAddFile}>
                    + Add Another File
                </button>
            </div>
        </div>
    );
};